// Catalog of external resources (Google Drive). Frontend-only constants.
// Drive download URL pattern: https://drive.google.com/uc?export=download&id={ID}
// Drive preview URL pattern:  https://drive.google.com/file/d/{ID}/view

export const BUSINESS_TEMPLATES_FOLDER =
  "https://drive.google.com/drive/folders/1ovdKWT892KGKmZuELVSsTdxP67syVnUj";

export const EDUCATOR_RESOURCES_FOLDER =
  "https://drive.google.com/drive/folders/1QT0_WRmNFduOZTtJjemuklQ6TeiRYEEL";

const file = (id, name, type, size) => ({
  id,
  name,
  type,                // "pdf" | "docx" | "xlsx"
  size,
  view: `https://drive.google.com/file/d/${id}/view`,
  download: `https://drive.google.com/uc?export=download&id=${id}`,
});

export const BUSINESS_TEMPLATES = [
  file("1e0XCRfLZ7v585t_iCgvFFoCQbeGrxyWh", "Business Plan Template (v2)", "docx", "452 KB"),
  file("1OHmjbbdAjYh35b_S2ZwwH5GEpvUXcoQr", "Online Profit Calculator", "xlsx", "10 KB"),
  file("11IYpXHcsQwFUR-pZP9blmlQKTdgwAGxu", "Budgeting Worksheet", "docx", "395 KB"),
  file("1ujO7mRdX8L8XcsUQtHKocIxZ8wRsUcDT", "Financial Planning Sheet", "docx", "451 KB"),
  file("1cIUyl7UKjOPoVHv7ziSgsYF0XrtBhi3i", "Marketing Strategy Worksheet", "docx", "451 KB"),
  file("1PcZIewhOIJDmXcI92hrYLWXAnXAKmnah", "Pitch Presentation Template", "docx", "451 KB"),
  file("11veb7IAzITrksi9bkQMgFxF64E9uv5mc", "Business Progress Tracker", "docx", "394 KB"),
  file("19wM5e1IsElJ8xKgFiQcSyMJNVHwqdg3P", "SMART Goals Template", "docx", "395 KB"),
  file("1oksFUEcpZE5Sw6bm85VSMJ3OcTLG6m7z", "Free Business Planning Tools Guide", "docx", "391 KB"),
  file("1WPyuqu-GIQHjuiywwTx4ZQpeKXGPCwLj", "Financial Literacy Games Guide", "pdf", "67 KB"),
];

// Educator resources — listed by name; users open the shared Drive folder
// (folder URL) to download. We keep file names visible so educators know
// what's inside before clicking.
export const EDUCATOR_RESOURCES = [
  { name: "The Lemonade Stand Business Plan Facilitator Guide", type: "pdf", size: "2.3 MB" },
  { name: "Educator Guide — Classroom Activities & Business Challenges", type: "docx", size: "395 KB" },
  { name: "LemonBot — AI-Powered Learning Educator Guide", type: "docx", size: "398 KB" },
  { name: "Pitch & Business Expo Event Planning Guide", type: "docx", size: "399 KB" },
  { name: "Lemonade Stand Sponsorship Deck", type: "docx", size: "398 KB" },
];
